import { css } from '@emotion/react';
import {
  colors,
  breakpoints,
  fonts,
  respondTo,
  respondFrom,
  fluidFontSize,
  dimensions
} from '~/styles';
import { fontFaces } from '~/styles/fonts';
import { bootstrap } from '~/styles/bootstrap';

export const globalStyles = css`
  ${fontFaces};
  /* ${bootstrap}; */

  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  html {
    ${fluidFontSize(12, dimensions.baseFontSize)}
  }

  body {
    width: 100%;
    min-width: ${breakpoints.xs}px;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: ${fonts.default};
    font-size: 1rem;
    line-height: 1.2;
    font-weight: normal;
    color: ${colors.text};
    background-color: ${colors.bg};
    position: relative;

    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    padding: 0;
    margin: 0;

    &.noscroll {
      overflow: hidden;
    }
    &.modal-opened {
      /* workaround for content covering fullscreen video */
      *:not(video) {
        z-index: 0;
      }
    }
  }

  a {
    cursor: pointer;
    text-decoration: underline;
    color: inherit;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  /* should be same style as <a> -- use Bootstrap <Button> if you need a button */
  button {
    appearance: none;
    -webkit-appearance: none;
    background: none;
    border: none;
    outline: none;
    padding: 0;
    font-family: ${fonts.default};
  }


  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    position: relative;
    display: inline-block;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.2em;
    font-weight: bold;
    text-rendering: optimizeLegibility;
    letter-spacing: -0.01em;
  }

  h1 {}

  h2 {}

  h3 {}

  h4 {}

  h5,
  h6 {}

  p,
  .p {
    margin-top: 0;
    margin-bottom: 0.5em;
  }

  strong {
    font-weight: bold;
  }

  ul,
  ol,
  dl {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  dt {
    font-weight: bold;
  }

  dd {
    margin-bottom: 0.5rem;
  }

  hr {
    position: relative;
    margin: 1.5rem 0;
    border: 0;
    border-top: 1px solid ${colors.text};
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    display: inline-block;
  }

  sup {
    vertical-align: super;
    font-size: 60%;
    line-height: 1;
  }

  img {
    max-width: 100%;
  }

  .inactive {
    opacity: 0.5;
    pointer-events: none;
  }

  .hoverable {
    cursor: pointer;
  }

  .blocked {
    pointer-events: none;
  }

  .desktop-only {
    ${respondTo(breakpoints.lg, css`
      display: none;
    `)};
  }

  .mobile-only {
    ${respondFrom(breakpoints.lg, css`
      display: none;
    `)};
  }

  ::-moz-selection {
    background: rgba(0,0,0,0.1);
  }

  ::selection {
    background: rgba(0,0,0,0.1);
  }
`


// WEBPACK FOOTER //
// ./src/styles/global.ts